import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();

  // ✅ Wait for token to load before deciding
  if (loading) {
    return <div>Loading...</div>; // Can be a spinner or better UI
  }

  // ✅ If no token, redirect to login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
